export default __webpack_public_path__ + "static/media/hht1_ep03_timeline_q03_a.a4dc4654.png";